import React, { Fragment } from 'react'
import withFloor from '../../components/withFloor'
import MainPage from './component/main'

const WrappedPage = props => (
    <Fragment>
        <MainPage {...props} />
    </Fragment>
)

const layout = true
const title = 'Home'
const keywords = []
const layoutMode = "public"

export default withFloor({ layout, keywords, title, layoutMode })(WrappedPage)
